import React from 'react'
import { connect } from 'react-redux'

import { updateConsultantInterests } from 'actions'
import { consultantInterestsSelector } from 'selectors'

import { Form, Field, Label, InterestsInput } from 'components/form'
import Button from 'components/Button'

class EditInterests extends React.Component {
  state = {
    interests: this.props.interests,
  }

  submit = e => {
    e.preventDefault()
    this.props.updateConsultantInterests(
      this.props.consultantId,
      this.state.interests
    )
    this.props.closeModal()
  }

  render() {
    return (
      <Form onSubmit={this.submit}>
        <Field>
          <Label htmlFor="interests">Hva er du flink til?</Label>
          <InterestsInput
            id="interests"
            value={this.state.interests}
            onChange={interests => this.setState({ interests })}
          />
        </Field>
        <Button type="submit">Lagre</Button>
      </Form>
    )
  }
}

const mapStateToProps = (state, { consultantId }) => ({
  consultantId,
  interests: consultantInterestsSelector(state, consultantId) || [],
})

const mapDispatchToProps = { updateConsultantInterests }

export default connect(mapStateToProps, mapDispatchToProps)(EditInterests)



// WEBPACK FOOTER //
// ./src/components/EditInterests.js